import React, { Component } from 'react';

export class VoteQuestionnaire extends Component {
    handleSelect = (event) => {
        // Selected id clicked
        const selectedId = parseInt(event.target.id)

        // Clone the array
        const options = [...this.props.options]

        // Clone and update each one (only 1 can be ticked)
        for (let i = 0; i < options.length; i++) {
            options[i] = { ...options[i] }
            if (options[i].ballotOptionId === selectedId) {
                options[i].score = event.target.value === "Yes" ? 1 : 0
            }
        }

        // Notify update
        this.props.onOptionsUpdate(options)
    }

    render() {
        return (
            <React.Fragment>
                {this.props.options.map((option) =>
                    <div key={option.ballotOptionId} className={'mb-2 py-2 overflow-auto ' + (option.isError ? "-mx-2 p-2 shadow-lg bg-red-100" : "")}>
                        <span>{(option.isOptional ? "(Optional) " : "") + option.ballotOptionName}</span>

                        <div className="float-right">
                            <input type="radio"
                                id={option.ballotOptionId}
                                name={option.ballotOptionId}
                                value="Yes"
                                disabled={this.props.hasVoted}
                                checked={option.score === 1}
                                onChange={this.handleSelect} />
                            <label htmlFor={option.ballotOptionId}
                                className="cursor-pointer disabled:cursor-default mr-4">Yes</label>

                            <input type="radio"
                                id={option.ballotOptionId}
                                name={option.ballotOptionId}
                                value="No"
                                disabled={this.props.hasVoted}
                                checked={option.score === 0}
                                onChange={this.handleSelect} />
                            <label htmlFor={option.ballotOptionId}
                                className="cursor-pointer disabled:cursor-default mr-4">No</label>
                        </div>
                    </div>
                )}
            </React.Fragment>
        );
    }
}